"use strict";
/**
 * @license
 * Copyright 2022 SOUTHWORKS UK LTD All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/southworks/codeverter/blob/main/LICENSE
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomGenerator = void 0;
const template_generator_1 = require("../template-generator");
const fs_1 = require("fs");
const path_1 = require("path");
class CustomGenerator extends template_generator_1.TemplateGenerator {
    constructor(filename) {
        super();
        const buffer = (0, fs_1.readFileSync)((0, path_1.resolve)(__dirname, filename));
        this.extension = (0, path_1.extname)(filename).replace(".t", "");
        this.addLine(buffer.toString());
    }
    getCustomHelpers(_) {
        return {};
    }
    getDefaultVisibilityOrder() {
        return [];
    }
    getDefaultValueMap(_) {
        return "";
    }
    getTypeMap(_) {
        return "";
    }
    getExtension() {
        return `.${this.extension}`;
    }
    getTemplate() {
        return this.getContent();
    }
}
exports.CustomGenerator = CustomGenerator;
